import { useEffect, useRef } from 'react';

const usePrevious = <T>(
  value: T | undefined,
  initialValue: T | undefined = undefined
): T | undefined => {
  const ref = useRef<T | undefined>(initialValue);

  useEffect(() => {
    ref.current = value;
  });

  return ref.current;
};

export default usePrevious;
